/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReImportType } from './ReImportType';
import {
    ReImportTypeFromJSON,
    ReImportTypeFromJSONTyped,
    ReImportTypeToJSON,
    ReImportTypeToJSONTyped,
} from './ReImportType';

/**
 * 
 * @export
 * @interface ReImportRequest
 */
export interface ReImportRequest {
    /**
     * 
     * @type {number}
     * @memberof ReImportRequest
     */
    timeFrom: number;
    /**
     * 
     * @type {number}
     * @memberof ReImportRequest
     */
    timeTo: number;
    /**
     * 
     * @type {string}
     * @memberof ReImportRequest
     */
    generatorKey: string;
    /**
     * 
     * @type {ReImportType}
     * @memberof ReImportRequest
     */
    type: ReImportType;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReImportRequest
     */
    metricKeys?: Array<string>;
}



/**
 * Check if a given object implements the ReImportRequest interface.
 */
export function instanceOfReImportRequest(value: object): value is ReImportRequest {
    if (!('timeFrom' in value) || value['timeFrom'] === undefined) return false;
    if (!('timeTo' in value) || value['timeTo'] === undefined) return false;
    if (!('generatorKey' in value) || value['generatorKey'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ReImportRequestFromJSON(json: any): ReImportRequest {
    return ReImportRequestFromJSONTyped(json, false);
}

export function ReImportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReImportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'timeFrom': json['timeFrom'],
        'timeTo': json['timeTo'],
        'generatorKey': json['generatorKey'],
        'type': ReImportTypeFromJSON(json['type']),
        'metricKeys': json['metricKeys'] == null ? undefined : json['metricKeys'],
    };
}

export function ReImportRequestToJSON(json: any): ReImportRequest {
    return ReImportRequestToJSONTyped(json, false);
}

export function ReImportRequestToJSONTyped(value?: ReImportRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeFrom': value['timeFrom'],
        'timeTo': value['timeTo'],
        'generatorKey': value['generatorKey'],
        'type': ReImportTypeToJSON(value['type']),
        'metricKeys': value['metricKeys'],
    };
}

